import { useDispatch, useSelector } from 'react-redux'
import * as React from 'react'
import dayjs, { Dayjs } from 'dayjs'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { v4 as uuidv4 } from 'uuid';
import NavBar from '../../structure/NavBar'
import { NavBarTop } from '../../structure/NavBarTop'
import AddIcon from '@mui/icons-material/Add'
import {
  updateTopHeader,
  uplodateLoading
} from '../../../redux/features/common/commonSlice'
import { useEffect, useState } from 'react'
import { NormalUserFilters } from './NormalUserFilters'
import { PaidUserFilters } from './PaidUserFilters'
import { NormalUserTable } from './NormalUserTable'
import { PaidUserTable } from './PaidUserTable'
import { SendUserWhatsAppModal } from './SendUserWhatsAppModal'
import urls from '../../constants/apiurl'
import ApiCaller from '../../constants/ApiCaller'
import { showDangerToast } from '../../constants/toaster'
import InsufficientPermission from '../../custom/InSufficientPermission'
import { useParams, useSearchParams, useNavigate } from 'react-router-dom' // Added useSearchParams and useNavigate

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`
  }
}

export const UserList = props => {

  const { referralCode } = useParams()
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [callAPiCallBack, setCallAPiCallBack] = useState(null)
  const [tabValue, setTabValue] = React.useState(0)
  const [paidSearchText, setPaidSearchText] = useState('')
  const [paidFilterClick, setPaidFilterClick] = useState()
  const [showBulkWhatsAppModal, setShowBulkWhatsAppModal] = useState(false)

  // Initialize filterData from URL params
  const [filterData, setFilterData] = useState(() => {
    return {
      searchText: searchParams.get('search') || '',
      contactNumber: searchParams.get('contactNumber') || '',
      accountStatus: searchParams.get('status') || '',
      startDate: searchParams.get('startDate') ? dayjs(searchParams.get('startDate')) : null,
      endDate: searchParams.get('endDate') ? dayjs(searchParams.get('endDate')) : null,
      subscription: '',
      isGrade: searchParams.get('grade') ? (searchParams.get('grade') === 'true' ? true : searchParams.get('grade') === 'false' ? false : null) : null,
      kycStatus: ''
    }
  })

  const dispatch = useDispatch()

  useEffect(() => {
    if (referralCode) {
      dispatch(updateTopHeader('Invited User Manager'))
    } else {
      dispatch(updateTopHeader('User Manager'))
    }
  }, [dispatch, referralCode])

  // const handleFilterClick = () => {
  //   setPaidFilterClick(new Date())
  // }


  // Handle filter click
  const handleFilterClick = React.useCallback(() => {
    // Update URL with filter params
    const params = new URLSearchParams();
    if (filterData.searchText) params.set('search', filterData.searchText);
    if (filterData.contactNumber) params.set('contactNumber', filterData.contactNumber);
    if (filterData.accountStatus) params.set('status', filterData.accountStatus);
    if (filterData.isGrade !== null) params.set('grade', filterData.isGrade.toString());
    if (filterData.startDate) params.set('startDate', filterData.startDate.format('YYYY-MM-DD'));
    if (filterData.endDate) params.set('endDate', filterData.endDate.format('YYYY-MM-DD'));

    navigate(`?${params.toString()}`, { replace: true });
    setCallAPiCallBack(uuidv4())
  }, [filterData]);


  const handleResetFilter = () => {
    setFilterData({
      searchText: '',
      contactNumber: '',
      accountStatus: '',
      startDate: null,
      endDate: null,
      subscription: '',
      kycStatus: '',
      isGrade: null
    })
    navigate('', { replace: true })
    setCallAPiCallBack(uuidv4())
  }

  const userPermisiions = useSelector(state => state?.permission)
  let currentModulePermission;
  let viewPermission = true;

  if (userPermisiions?.modules?.length > 0) {
    currentModulePermission = userPermisiions.modules.find((element) => {
      if (element.moduleId === '4') {
        return element
      }
    })?.permissions
    viewPermission = currentModulePermission.find((element) => {
      if (element.name === 'VIEW') {
        return element
      }
    }).isEnable
  }


  return (
    <>
      <SendUserWhatsAppModal
        show={showBulkWhatsAppModal}
        onHide={() => setShowBulkWhatsAppModal(false)}
        mode="bulk"
      />
      <NavBar />
      <div className='main-content'>
        <NavBarTop />
        <div className='header'>
          <div className='logo'>
            <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
          </div>
        </div>
        {
          viewPermission ? (
            <>
              <div className='container-fluid mt--7'>
                <div className='row'>
                  <div className='col text-left'>
                    <div className='card shadow'>
                      <div className='card-header border-0'>
                        <div className='row align-items-center text-left'>
                          <div className='col'>
                            <h3 className='mb-0'>User List</h3>
                          </div>
                          <div className='col-auto'>
                            <Button
                              variant="contained"
                              size="small"
                              startIcon={<WhatsAppIcon />}
                              onClick={() => setShowBulkWhatsAppModal(true)}
                              sx={{
                                bgcolor: '#25D366',
                                textTransform: 'none',
                                fontWeight: 600,
                                boxShadow: '0 4px 12px rgba(37, 211, 102, 0.3)',
                                '&:hover': { bgcolor: '#1ebe57' },
                              }}
                            >
                              Send WhatsApp to all
                            </Button>
                          </div>
                        </div>
                      </div>
                      <NormalUserFilters
                        handleFilterClick={handleFilterClick}
                        handleResetFilter={handleResetFilter}
                        setFilterData={setFilterData}
                        filterData={filterData}
                      />
                      <div className='card-header border-0'>
                        <div className='row align-items-center text-left'>
                        </div>
                      </div>
                      <NormalUserTable
                        referralCode={referralCode}
                        filterData={filterData}
                        callAPiCallBack={callAPiCallBack}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (<InsufficientPermission />)
        }
      </div>
    </>
  )
}
